export { toTitleCase, capitalize } from './string';
